export type AnalyticsGroupIconProps = {
    size?: number;
    color?: string;
};

export function AnalyticsGroupIcon({ size = 16, color }: AnalyticsGroupIconProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 499.79 362.91"
            width={size}
            fill={color ?? 'currentColor'}
        >
            <g id="Layer_2" data-name="Layer 2">
                <g id="Layer_1-2" data-name="Layer 1">
                    <path d="M499.79,168.45A110,110,0,0,0,408.47,60h0L88.38,1.19l0,0A75,75,0,0,0,5.43,103h0l0,.07a75.18,75.18,0,0,0,15.09,23.44L156.81,338.28c.66,1.1,1.35,2.18,2.09,3.23l.15.24h0a50,50,0,0,0,60.08,17.32h0l.11-.05.17-.07,201-84.82h0A110.05,110.05,0,0,0,499.79,168.45ZM199.9,262.91A50,50,0,0,0,153,295.45L58.2,148.09A75,75,0,0,0,150,75a74.72,74.72,0,0,0-14.91-44.89L343.84,68.48A110,110,0,0,0,365.25,275.7L248.42,325a50,50,0,0,0-48.52-62.1Z" />
                </g>
            </g>
        </svg>
    );
}
